import { defineMessages } from "react-intl";

export default defineMessages({
  bancontact: {
    id: "configureBancontact.bancontact",
    defaultMessage: "Bancontact",
  },
  submit: {
    id: "configureBancontact.submit",
    defaultMessage: "Submit",
  },
});
